
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard } from '@/components';
import { useDuplicateCycleList } from '@/modules/duplicate/cycle/model/list';
import { DuplicateCycleStatus } from '@/modules/duplicate/cycle/model/mixins';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.CYCLE.INDEX,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, query, fetchList } = useDuplicateCycleList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Item',
                    key: 'itemName',
                    to: (row: any) => ({ name: ROUTE_NAME_DUPLICATE.ITEM.DETAIL, params: { id: row.duplicateItemId } })
                },
                { type: TableColumnType.Text, label: 'Cycle', key: 'id' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Match',
                    key: 'matchName',
                    to: (row: any) => ({ name: ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: row.matchId } })
                },
                {
                    type: TableColumnType.Html,
                    label: 'Unlocked Game',
                    htmlHandler: (row: any) => `${row.unlockedGame}/${row.itemGame}`
                },
                { type: TableColumnType.DateTime, label: 'Open Time', key: 'openTime' },
                { type: TableColumnType.DateTime, label: 'Close Time', key: 'closeTime' },
                { type: TableColumnType.DateTime, label: 'Rank Time', key: 'rankTime' },
                { type: TableColumnType.DateTime, label: 'Archive Time', key: 'archiveTime' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: DuplicateCycleStatus },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_DUPLICATE.CYCLE.DETAIL, params: { cycleId: row.id } }
                    })
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-ticket-alt',
                        theme: 'info',
                        tooltip: 'Show deck',
                        to: {
                            name: ROUTE_NAME_DUPLICATE.CYCLE.DECK,
                            params: { cycleId: row.id, itemId: row.duplicateItemId }
                        }
                    })
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-crown',
                        theme: 'info',
                        tooltip: 'Show ranking',
                        to: {
                            name: ROUTE_NAME_DUPLICATE.CYCLE.RANK,
                            params: { cycleId: row.id, itemId: row.duplicateItemId }
                        }
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList };
    }
});
